export default {"src":"/_next/static/media/chestpress.8f0f9dad.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};